var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.346,
    height: 13.999,
    viewBox: "0 0 13.346 13.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_214932",
    "data-name": "Path 214932",
    d: "M8.294,17a1.391,1.391,0,0,1-1.111-.553L3.61,11.724a1.394,1.394,0,1,1,2.223-1.681l2.351,3.1L14.1,3.655A1.394,1.394,0,0,1,16.462,5.13L9.478,16.34A1.39,1.39,0,0,1,8.358,17C8.336,17,8.316,17,8.294,17Z",
    transform: "translate(-3.328 -3)",
    fill: "#21b560"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/check_green.1298fdbbf771c8289e9981568404c146.svg";
export { ForwardRef as ReactComponent };